import React, { useState } from 'react';
import { Link, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { FaHome, FaUserFriends, FaTasks, FaListAlt, FaChartLine, FaCog, FaSignOutAlt, FaBars, FaTimes, FaArrowLeft } from 'react-icons/fa';
import './Layout.css';

function Layout({ children }) {
    const [menuOpen, setMenuOpen] = useState(false);
    const [collapsed, setCollapsed] = useState(true);
    const location = useLocation();
    const navigate = useNavigate();

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const toggleSidebar = () => {
        setCollapsed(!collapsed);
    };

    const pageTitleMap = {
        "/home": "Home",
        "/care-recipients": "Care Recipients",
        "/activities": "Activities",
        "/priceList": "Price List",
        "/staff-demand-report": "Staff Demand Report",
        "/settings": "Settings",
    };

    const pageTitle = pageTitleMap[location.pathname] || "Dashboard";

    return (
        <div className={`layout-container ${collapsed ? 'collapsed' : ''}`}>
            <aside className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
                <div className="sidebar-header">
                    <button className="toggle-sidebar-btn" onClick={toggleSidebar}>
                        {collapsed ? <FaBars /> : <FaTimes />}
                    </button>
                    {!collapsed && (
                        <img
                            src={"https://bitbucket.org/imagin8apps/test/raw/33205391b4155a86555d730cd4bc2c523c380406/public/HeaderLogo.png"}
                            alt="Logo"
                            className="logo"
                        />
                    )}
                </div>
                <nav>
                    <ul>
                        <li><Link to="/home"><FaHome /> {!collapsed && "Home"}</Link></li>
                        <li><Link to="/care-recipients"><FaUserFriends /> {!collapsed && "Care Recipients"}</Link></li>
                        <li><Link to="/activities"><FaTasks /> {!collapsed && "Activities"}</Link></li>
                        <li><Link to="/priceList"><FaListAlt /> {!collapsed && "Price List"}</Link></li>
                        <li><Link to="/staff-demand-report"><FaChartLine /> {!collapsed && "Staff Demand Report"}</Link></li>
                        <li><Link to="/settings"><FaCog /> {!collapsed && "Settings"}</Link></li>
                    </ul>
                </nav>
            </aside>
            <main className="content">
                <div className='topbar'>
                    <FaCog className="topbar-cog" onClick={toggleMenu} />
                    {menuOpen && (
                        <div className="dropdown-menu">
                            <Link to="/settings" className="dropdown-item">
                                <FaCog /> Settings
                            </Link>
                            <Link to="/logout" className="dropdown-item">
                                <FaSignOutAlt /> Logout
                            </Link>
                        </div>
                    )}
                </div>
                <div className="page-load" style={{ padding: 20 }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                        {location.pathname !== "/" && (
                            <button
                                className="back-button"
                                onClick={() => {
                                    if (location.pathname.split("/").filter(Boolean).length === 1) {
                                        navigate("/home");
                                    } else {
                                        navigate(-1);
                                    }
                                }}
                            >
                                <FaArrowLeft />
                            </button>
                        )}
                        {location.pathname !== "/" && (<h2 className="topbar-title mb-0" style={{ marginLeft: 10 }}>{pageTitle}</h2>)}
                    </div>
                    <Outlet />
                </div>
            </main>
        </div>
    );
}

export default Layout;